<ng-container [formGroup]="form">
  <mat-select #select formControlName="code" class="mobile-phone__code">
    <mat-option *ngFor="let code of codeList; trackBy: trackCode" [value]="code"
      >+{{ code }}</mat-option
    >
  </mat-select>
  <input
    #input
    matInput
    type="tel"
    [placeholder]="placeholder"
    formControlName="number"
    class="mobile-phone__number"
    (paste)="onPaste($event)"
    (blur)="onBlur()"
  />
</ng-container>
